import { useState } from "react";
import InputField from "../atoms/InputField";
import ActionButton from "../atoms/ActionButton";
import { login } from "../../services/authService";

/**
 * LoginForm - ログインフォーム
 * @param {function} onLogin - ログイン成功時のコールバック
 */
function LoginForm({ onLogin }) {
  const [userId, setUserId] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);
    try {
      const success = await login(userId, password);
      if (success) {
        onLogin();
      } else {
        setError("ユーザーIDまたはパスワードが正しくありません");
      }
    } catch {
      setError("通信エラーが発生しました。サーバーを確認してください。");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-4">
      <div className="flex flex-col gap-1">
        <label className="text-sm text-gray-600">ユーザーID</label>
        <InputField
          value={userId}
          onChange={(e) => setUserId(e.target.value)}
          numericOnly={false}
          textAlignClass="text-left"
          sizeClass="px-3 py-2 text-sm"
          widthClass="w-full"
          borderClass="border border-gray-300 rounded focus:outline-none focus:border-blue-500"
        />
      </div>
      <div className="flex flex-col gap-1">
        <label className="text-sm text-gray-600">パスワード</label>
        <InputField
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          numericOnly={false}
          type="password"
          textAlignClass="text-left"
          sizeClass="px-3 py-2 text-sm"
          widthClass="w-full"
          borderClass="border border-gray-300 rounded focus:outline-none focus:border-blue-500"
        />
      </div>
      {error && <p className="text-sm text-red-500">{error}</p>}
      <div className="mt-2">
        <ActionButton
          label={isLoading ? "確認中..." : "ログイン"}
          type="submit"
          disabled={isLoading}
          paddingClass="px-4 py-2"
          textSizeClass="text-lg font-bold"
          colorClass="bg-blue-600 text-white hover:bg-blue-700 border-blue-600"
          widthClass="w-full"
        />
      </div>
    </form>
  );
}

export default LoginForm;
